<div class="modal-overlay" (click)="fechar()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Solicitar Férias</h2>
      <button class="btn-close" (click)="fechar()">&times;</button>
    </div>

    <div class="modal-body">
      <p class="modal-description">Indique o período de férias.</p>
      
      <form [formGroup]="FeriasForm" (ngSubmit)="enviarSolicitacaoFerias()">
        <div class="form-inicio">
          <label for="InicioFerias">Data de início</label>
          <input 
            type="date" 
            class="form-control" 
            id="DataInicio" 
            formControlName="DataInicio">  
        </div>

        <div class="form-fim">
          <label for="FimFerias">Data de fim </label>
          <input 
            type="date" 
            class="form-control" 
            id="DataFim" 
            formControlName="DataFim">  
        </div>

        <div class="form-observacao">
          <label for="Observacao">Observação</label>
          <textarea 
            class="form-control" 
            id="Observacao" 
            formControlName="Observacao" 
            rows="3" 
            placeholder="Digite uma observação (opicional)"></textarea>
        </div>

        <div *ngIf="FeriasForm.invalid && (FeriasForm.get('DataInicio')?.touched || FeriasForm.get('DataFim')?.touched)">
          <div *ngIf="FeriasForm.get('DataInicio')?.hasError('required')" class="formatacaoRequireds">
            *Data de início é obrigatória
          </div>
          <div *ngIf="FeriasForm.get('DataFim')?.hasError('required')" class="formatacaoRequireds">
            *Data de fim é obrigatória
          </div>
        </div>

        <div class="modal-buttons">
          <button type="submit" class="btn-enviar">
            Enviar
          </button>
        </div>
      </form>
    </div>